import script from "./StepConfigurator.vue?vue&type=script&setup=true&lang=js"
export * from "./StepConfigurator.vue?vue&type=script&setup=true&lang=js"

import "./StepConfigurator.vue?vue&type=style&index=0&id=7ac3d034&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ac3d034"]])

export default __exports__